<template>
  <b-overlay :show="regionBusy">
    <portlet title="يېڭىدىن رايون قوشۇش">
      <template v-slot:body>
        <region-form
          ref="region"
          @storing="onStoring"
          @stored="onStored"
        />
      </template>
      <template v-slot:foot>
        <b-button id="submit" @click="handleSubmit" variant="primary">
          ساقلاش
        </b-button>
        <b-button class="ml-2" variant="danger">
          بىكار قىلىش
        </b-button>
      </template>
    </portlet>
  </b-overlay>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import RegionForm from "@v@/components/forms/RegionForm";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import { debugConsole } from "@c@/helpers/helpers";
  export default {
    name: "index",
    components: { Portlet, RegionForm },
    mixins: [ formBusyMixin ],
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'رايۇن باشقۇرۇش', route: {name: 'region.home'}});
      BreadCrumbs.addBreadCrumb({title: 'يېڭىدىن رايون قوشۇش'});
      if ( this.$refs.hasOwnProperty('region') ){
        this.form = this.$refs['region'];
      }
    },
    data(){
      return {
        regionBusy: false,
        form: {}
      };
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onStoring(){
        this.showBusy('regionBusy');
        debugConsole({prefix: 'region', message: `onStored`});
      },
      onStored(state){
        this.hideBusy('regionBusy');
        debugConsole({prefix: 'region', message: `onStored: ${state}`});
        this.$router.replace({name: 'region.home'});
      }
    }
  }
</script>

<style scoped>

</style>
